@if (useNewFooter) {
  <div class="af-footer af-footer--new">
  <section class="af-footer-inner">
      <p class="af-footer-partners-title">Our partners</p>

      <div class="af-footer-logos for-big">
      <a href="https://deepmind.google/" target="_blank">
          <img src="../../assets/img/Google_DeepMind_Logo_new.webp" style="width:188px; height:25px" alt="Google Deepmind">
      </a>
      <a href="https://www.ebi.ac.uk/" target="_blank">
          <img src="../../assets/img/ebi-logo.webp" alt="EMBL-EBI" width="568" height="175">
      </a>
      </div>

      <div class="af-footer-logos for-mobile">
      <a href="https://deepmind.google/" target="_blank">
          <img src="../../assets/img/Google_DeepMind_Logo_small.webp" style="height:15px" alt="Google Deepmind" width="189" height="26">
      </a>
      <a href="https://www.ebi.ac.uk/" target="_blank">
          <img src="../../assets/img/ebi-logo.webp" alt="EMBL-EBI" width="568" height="175">
      </a>
      </div>
  </section>
  </div>
} @else {
  <div class="af-footer">
  <div class="row new-row">
      <div class="small-5 columns af-footer-text">Developed by</div>
      <div class="small-7 columns af-footer-logos for-big">
      <a href="https://deepmind.google/" target="_blank">
          <img src="../../assets/img/Google_DeepMind_Logo_new.webp" style="width:188px; height:25px" alt="Google Deepmind">
      </a>
      <a href="https://www.ebi.ac.uk/" target="_blank">
          <img src="../../assets/img/ebi-logo.webp" alt="EMBL-EBI" width="568" height="175">
      </a>
      </div>
      <div class="af-footer-logos for-mobile" style="display: flex;">
      <a href="https://deepmind.google/" target="_blank">
          <img src="../../assets/img/Google_DeepMind_Logo_small.webp" style="height:15px" alt="Google Deepmind" width="189" height="26">
      </a>

      <a href="https://www.ebi.ac.uk/" target="_blank">
          <img src="../../assets/img/ebi-logo.webp" alt="EMBL-EBI" width="568" height="175">
      </a>
      </div>
  </div>
  </div>
}
